<script setup>
import { Overlay,LoadingDummyP,H1Title, } from '@/assets/js/src/components/all'
import { useTranslation,useHandleRoutableLink,usePrefetchData, } from '@/assets/js/src/util/composables'
import { useHeadInfoTitle, } from '@/assets/js/src/layout/useHeadInfo'

let { messagesLoaded, } = usePrefetchData({
    loadAsyncMessages: [ 'accessibility', 'common', ],
})

const { handleRoutableLink, } = useHandleRoutableLink()
const { t, } = useTranslation()
const { title, } = useHeadInfoTitle({ titleKey: 'async.accessibility.title', })
</script>

<template>
    <overlay
        class-name="accessibility"
    >
        <h1-title :messages-keys="['accessibility']">
            {{ title }}
        </h1-title>

        <div
            v-if="messagesLoaded"
            class="accessibility__content"
            @click="handleRoutableLink"
            v-html="t('async.accessibility.text')"
        >
        </div>
        <template
            v-else
        >
            <loading-dummy-p
                count="4"
                height="18px"
                margin="8px 0"
                key-prefix="dummy_3"
            ></loading-dummy-p>
            <loading-dummy-p
                count="6"
                height="18px"
                margin="8px 0"
                key-prefix="dummy_4"
            ></loading-dummy-p>
        </template>
    </overlay>
</template>

<style lang="scss">
.bs-app .accessibility {
    ul {
        margin-bottom: 16px;
    }
}
</style>
